import React from 'react';
import DevolucionesBase from './DevolucionesBase.jsx';

export default function DevolucionesPage() {
  return <DevolucionesBase kind="devolucion" />;
}
